import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["s2s"],
  iconColor: "#7081FF", // pluto
  getIcon(options) {
    return createIcon(
      `
        <path d="M4.92324 13.1C4.92324 14.25 5.72324 15.05 7.07324 15.05C8.42324 15.05 9.27324 14.21 9.27324 13.3C9.27324 11 5.92324 11.7 5.92324 10.4C5.92324 9.95 6.37324 9.5 7.07324 9.5C7.72324 9.5 8.17324 9.95 8.17324 10.6H9.12324C9.12324 9.51 8.27324 8.65 7.07324 8.65C5.82324 8.65 4.97324 9.49 4.97324 10.4C4.97324 12.6 8.32324 11.9 8.32324 13.3C8.32324 13.81 7.92324 14.2 7.07324 14.2C6.27324 14.2 5.87324 13.81 5.87324 13.1H4.92324ZM9.97324 15H14.0232V14.1H11.3332L13.1232 12.15C13.2932 11.98 13.4432 11.81 13.5732 11.63C13.8032 11.32 14.0232 10.9 14.0232 10.5C14.0232 9.45 13.2232 8.65 11.9732 8.65C10.7232 8.65 9.92324 9.45 9.92324 10.6H10.8732C10.8732 9.95 11.3232 9.5 11.9732 9.5C12.6832 9.5 13.0732 9.89 13.0732 10.45C13.0732 10.73 12.9232 11 12.7732 11.23C12.6832 11.36 12.5832 11.48 12.4732 11.6L9.97324 14.3V15ZM14.7768 13.1C14.7768 14.25 15.5768 15.05 16.9268 15.05C18.2768 15.05 19.1268 14.21 19.1268 13.3C19.1268 11 15.7768 11.7 15.7768 10.4C15.7768 9.95 16.2268 9.5 16.9268 9.5C17.5768 9.5 18.0268 9.95 18.0268 10.6H18.9768C18.9768 9.51 18.1268 8.65 16.9268 8.65C15.6768 8.65 14.8268 9.49 14.8268 10.4C14.8268 12.6 18.1768 11.9 18.1768 13.3C18.1768 13.81 17.7768 14.2 16.9268 14.2C16.1268 14.2 15.7268 13.81 15.7268 13.1H14.7768Z" fill="#021330"/>
      `,
      "#F3F4FF", // cosmic-4
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
